import typeUtils from './helpers/utils/typeUtils.js.es6';
import constants from './helpers/constants.js.es6';

let headerProps;
let contentRequests = {};

function init(args){
    if(!Array.isArray(args)) { return; }

    /**
     * Args is an array of ruby-provided values to the ERB that must be passed to the javascript.
     * An unnamed list of values is used for obfuscation purposes.
     *
     * args = [
     *      String appName,
     *      String id,
     *      String title,
     *      Boolean rightsAccess,
     *      Boolean readOnly,
     *      Boolean betaUser
     *  ]
    **/

    headerProps = args;
}

function initContentRequests(data){
    if(!typeUtils.isObject(data)){ return; }

    contentRequests = data;
}

export const BOOKLIST = {
    name:'Vitalsource Booklist Manager',
    description:'Root namespace to contain all of the Booklist Manager apps react components',
    components:{
        Time: require('react-time').default
    },
    constants: constants,
    init: init,
    initContentRequests: initContentRequests,
    getHeaderProps: getHeaderProps,
    getContentRequests: getContentRequests
};

function getHeaderProps() { return headerProps; }
function getContentRequests() { return contentRequests; }